import React, { useState, useEffect } from "react";
import { Container, Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";

// Icons
import { FaLock, FaBars } from "react-icons/fa";
import { FaLockOpen } from "react-icons/fa6";
import { RiFileList2Fill } from "react-icons/ri";

// Logos
import logo from "../images/amotive-orange-revert.png";
import logoInvert from "../images/sud-ricambi-logo-symbol-white.png";
import logoInvert2 from "../images/TP-_logo-symbol-white.png";
import logoQlik from "../images/qlik2.png";

function BasicExample() {
  const [isLocked, setIsLocked] = useState(() => {
    const lockedState = localStorage.getItem("isLocked");

    return lockedState
      ? JSON.parse(lockedState)
      : true;
  });

  /* =========================================================
     LOCK SESSIONE

     CHIUSO:
     - bottone bianco
     - lucchetto arancione
     - aggiorna la pagina corrente ogni 150 secondi

     APERTO:
     - bottone glass
     - lucchetto bianco
     - dopo 150 secondi torna su /amotive
     ========================================================= */

  useEffect(() => {
    localStorage.setItem(
      "isLocked",
      JSON.stringify(isLocked),
    );

    const intervalId = isLocked
      ? setInterval(() => {
          window.location.reload();
        }, 150000)
      : setInterval(() => {
          window.location.href = "/amotive";
        }, 150000);

    return () => clearInterval(intervalId);
  }, [isLocked]);

  return (
    <Navbar
      expand="lg"
      className="
        ombra-dark
        m-3
        mb-0
        mt-2
        px-4
        py-2
        border-0
        custom-amotive-nav
      "
      style={{
        borderRadius: "50px",
        minHeight: "60px",
      }}
    >
      <Container
        fluid
        className="p-0"
      >
        {/* LOGO */}

        <Navbar.Brand
          as={Link}
          to="/home"
          className="d-flex align-items-center"
        >
          <img
            src={logo}
            alt="Amotive"
            style={{
              height: "30px",
              width: "auto",
            }}
          />
        </Navbar.Brand>

        {/* TOGGLE MOBILE */}

        <Navbar.Toggle
          aria-controls="navbar-responsive-amotive"
          className="border-0 shadow-none"
        >
          <FaBars
            style={{
              color: "white",
            }}
          />
        </Navbar.Toggle>

        <Navbar.Collapse id="navbar-responsive-amotive">
          <div
            className="
              d-flex
              flex-column
              flex-lg-row
              align-items-lg-center
              w-100
              mt-3
              mt-lg-0
            "
          >
            {/* =====================================================
                LINK SINISTRA
                ===================================================== */}

            <div
              className="
                d-flex
                flex-wrap
                align-items-center
                gap-3
                ms-lg-4
              "
            >
              <Link
                to="/ordini-urgenti"
                className="amotive-nav-link text-decoration-none"
              >
                <RiFileList2Fill className="me-1 fs-5" />

                ORDINI URGENTI
              </Link>

              <div className="amotive-nav-separator d-none d-lg-block" />

              <Link
                to="/sud-ricambi"
                className="amotive-nav-link text-decoration-none"
              >
                <img
                  src={logoInvert}
                  alt=""
                  className="amotive-brand-icon"
                />

                SUD RICAMBI
              </Link>

              <Link
                to="/technoparts"
                className="amotive-nav-link text-decoration-none"
              >
                <img
                  src={logoInvert2}
                  alt=""
                  className="amotive-brand-icon"
                />

                TECHNOPARTS
              </Link>
            </div>

            {/* =====================================================
                AZIONI DESTRA
                ===================================================== */}

            <div
              className="
                d-flex
                align-items-center
                gap-3
                ms-auto
                mt-3
                mt-lg-0
              "
            >
              {/* QLIK */}

              <a
                href="https://dashboard.technoparts.it/qlik/ar.html"
                target="_blank"
                rel="noreferrer"
                className="amotive-action-btn text-decoration-none"
              >
                <img
                  src={logoQlik}
                  alt="Qlik"
                  style={{
                    width: "18px",
                  }}
                />

                <span className="ms-2 d-none d-xl-inline">
                  QLIK
                </span>
              </a>

              <div className="amotive-nav-separator d-none d-lg-block" />

              {/* =====================================================
                  LOCK
                  ===================================================== */}

              <button
                type="button"
                onClick={() =>
                  setIsLocked((prev) => !prev)
                }
                className={`
                  amotive-action-btn
                  amotive-circle-btn
                  amotive-session-lock
                  ${
                    isLocked
                      ? "amotive-lock-closed"
                      : "amotive-lock-open"
                  }
                `}
                title={
                  isLocked
                    ? "Sessione chiusa - clicca per aprire"
                    : "Sessione aperta - clicca per chiudere"
                }
                aria-label={
                  isLocked
                    ? "Apri sessione"
                    : "Chiudi sessione"
                }
                aria-pressed={!isLocked}
              >
                {isLocked ? (
                  <FaLock className="amotive-lock-icon" />
                ) : (
                  <FaLockOpen className="amotive-lock-icon" />
                )}
              </button>
            </div>
          </div>
        </Navbar.Collapse>
      </Container>

      {/* =========================================================
          CSS INTEGRATO
          ========================================================= */}

      <style>{`
        /* =====================================================
           NAVBAR AMOTIVE
           ===================================================== */

        .custom-amotive-nav {
          position:
            relative !important;

          z-index:
            1030 !important;

          overflow:
            visible !important;

          background:
            linear-gradient(
              135deg,
              rgba(241,111,36,0.98),
              rgba(211,82,15,0.96)
            ) !important;

          border:
            1px solid rgba(255,255,255,0.10) !important;

          box-shadow:
            0 12px 28px rgba(0,0,0,0.28),
            inset 0 1px 0 rgba(255,255,255,0.14) !important;

          backdrop-filter:
            blur(18px)
            saturate(130%);

          -webkit-backdrop-filter:
            blur(18px)
            saturate(130%);
        }

        .custom-amotive-nav
        > .container-fluid,
        .custom-amotive-nav
        .navbar-collapse {
          overflow:
            visible !important;
        }


        /* =====================================================
           LINK
           ===================================================== */

        .amotive-nav-link {
          color:
            rgba(255,255,255,0.90) !important;

          font-size:
            0.75rem;

          font-weight:
            650;

          display:
            flex;

          align-items:
            center;

          transition:
            color 0.18s ease,
            transform 0.18s ease;
        }

        .amotive-nav-link:hover {
          color:
            #ffffff !important;

          transform:
            translateY(-1px);
        }

        .amotive-brand-icon {
          width:
            20px;

          height:
            20px;

          margin-right:
            8px;

          object-fit:
            contain;

          filter:
            brightness(0)
            invert(1);
        }


        /* =====================================================
           ACTION BUTTON
           ===================================================== */

        .custom-amotive-nav
        .amotive-action-btn {
          position:
            relative;

          display:
            flex;

          align-items:
            center;

          justify-content:
            center;

          height:
            36px;

          padding:
            6px
            14px;

          color:
            #ffffff !important;

          background:
            rgba(255,255,255,0.15) !important;

          border:
            1px solid rgba(255,255,255,0.11) !important;

          border-radius:
            50px;

          box-shadow:
            inset 0 1px 0 rgba(255,255,255,0.10);

          font-size:
            0.70rem;

          font-weight:
            750;

          cursor:
            pointer;

          transition:
            background 0.18s ease,
            border-color 0.18s ease,
            transform 0.18s ease,
            box-shadow 0.18s ease;
        }

        .custom-amotive-nav
        .amotive-action-btn:hover {
          color:
            #ffffff !important;

          background:
            rgba(255,255,255,0.24) !important;

          border-color:
            rgba(255,255,255,0.28) !important;

          transform:
            translateY(-1px);
        }


        /* =====================================================
           LOCK
           CHIUSO = BLOCCO BIANCO + LUCCHETTO ARANCIONE
           ===================================================== */

        .amotive-circle-btn {
          width:
            36px;

          min-width:
            36px;

          padding:
            0 !important;

          border-radius:
            50% !important;
        }

        .custom-amotive-nav
        .amotive-session-lock.amotive-lock-closed {
          color:
            #f16f24 !important;

          background:
            #ffffff !important;

          border-color:
            rgba(255,255,255,0.98) !important;

          box-shadow:
            0 5px 14px rgba(110,46,10,0.18),
            inset 0 1px 0 rgba(255,255,255,1) !important;
        }

        .custom-amotive-nav
        .amotive-session-lock.amotive-lock-closed:hover {
          color:
            #d85b14 !important;

          background:
            #f8f8f8 !important;
        }

        .custom-amotive-nav
        .amotive-session-lock.amotive-lock-closed
        svg {
          color:
            #f16f24 !important;

          fill:
            currentColor !important;
        }


        /* =====================================================
           LOCK APERTO
           ===================================================== */

        .custom-amotive-nav
        .amotive-session-lock.amotive-lock-open {
          color:
            #ffffff !important;

          background:
            rgba(255,255,255,0.12) !important;

          border-color:
            rgba(255,255,255,0.18) !important;
        }

        .custom-amotive-nav
        .amotive-session-lock.amotive-lock-open
        svg {
          color:
            #ffffff !important;

          fill:
            currentColor !important;
        }

        .amotive-lock-icon {
          font-size:
            0.88rem;
        }


        /* =====================================================
           SEPARATORE
           ===================================================== */

        .amotive-nav-separator {
          width:
            1px;

          height:
            20px;

          margin:
            0 5px;

          background:
            rgba(255,255,255,0.30);
        }


        /* =====================================================
           SHADOW
           ===================================================== */

        .ombra-dark {
          box-shadow:
            0 4px 20px rgba(0,0,0,0.30);
        }


        /* =====================================================
           COLLAPSE
           ===================================================== */

        #navbar-responsive-amotive {
          position:
            relative;

          z-index:
            1035;

          flex-direction:
            column;

          align-items:
            flex-start;

          overflow:
            visible !important;

          background:
            transparent !important;
        }


        /* =====================================================
           MOBILE
           ===================================================== */

        @media screen and (max-width: 991px) {
          .custom-amotive-nav {
            overflow:
              visible !important;
          }

          .custom-amotive-nav
          .navbar-collapse {
            overflow:
              visible !important;
          }
        }
      `}</style>
    </Navbar>
  );
}

export default BasicExample;